import { useMutation, useQueryClient } from '@tanstack/react-query';
import { softDeleteTeacher } from '@services/registry';

export function useSoftDeleteTeacher({ tenantId }) {
    const qc = useQueryClient();
    return useMutation({
        mutationFn: async ({ teacherId }) => {
            return await softDeleteTeacher({ tenantId, teacherId });
        },
        onSuccess: () => {
            qc.invalidateQueries({ queryKey: ['teachers', tenantId] });
            qc.invalidateQueries({ queryKey: ['teacherKpis', tenantId] });
        },
    });
}
